import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { ICheckboxStyles } from "./Checkbox.types"

export const CheckboxStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<ICheckboxStyles>
> = (theme: IPartialTheme) => ({
    root: {
        selectors: {
            "input:focus + label::before": {
                // unfortunately we need to use important here because the outline color is set with a very
                // specific rule wich applies to fluents root ms-Fabric--isFocusVisible component
                outlineColor: `${theme?.semanticColors?.focusBorder} !important`
            },
            ".ms-Checkbox:not(.is-checked):not(.is-disabled) .ms-Checkbox-checkbox":
                {
                    borderColor: theme?.palette?.neutralTertiary
                },
            ".ms-Checkbox:not(.is-checked):not(.is-disabled) :hover .ms-Checkbox-checkbox":
                {
                    borderColor: theme?.palette?.neutralSecondary
                },
            ".ms-Checkbox:not(.is-checked).is-disabled .ms-Checkbox-checkbox": {
                borderColor: theme?.semanticColors?.buttonBackgroundDisabled
            },
            ".ms-Checkbox:not(.is-checked).is-disabled :hover .ms-Checkbox-checkbox":
                {
                    borderColor: theme?.semanticColors?.buttonBackgroundDisabled
                },
            ".ms-Checkbox:not(.is-checked) :hover .ms-Checkbox-checkmark": {
                opacity: 0
            }
        }
    },
    mandatoryRoot: {
        ".ms-Checkbox:not(.is-checked):not(.is-disabled) .ms-Checkbox-checkbox":
            {
                borderColor: theme.semanticColors?.warningIcon,
                backgroundColor: theme.semanticColors?.warningBackground
            },
        ".ms-Checkbox:not(.is-checked):not(.is-disabled) :hover .ms-Checkbox-checkbox":
            {
                borderColor: theme.semanticColors?.warningIcon,
                backgroundColor: theme.semanticColors?.warningBackground
            }
    },
    checkboxContainer: {
        marginTop: "1.5em",
        alignItems: "center"
    },
    label: {
        minWidth: 0,
        fontWeight: 400,
        padding: 0
    },
    textContainer: {
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    checkbox: {
        minWidth: 20,
        selectors: {
            ".ms-Checkbox-label": {
                minWidth: 0
            },
            ".ms-Checkbox-checkbox": {
                borderRadius: 0
            }
        }
    },
    price: {
        color: theme?.palette?.neutralSecondary,
        marginRight: "1em"
    },
    conflict: {
        selectors: {
            ".ms-Checkbox-checkbox": {
                borderColor: theme?.palette?.neutralTertiary,
                backgroundColor: theme?.palette?.neutralTertiary
            },
            ":hover .ms-Checkbox-checkbox": {
                borderColor: theme?.palette?.neutralSecondary,
                backgroundColor: theme?.palette?.neutralSecondary
            },
            ".ms-Checkbox-checkmark": {
                color: theme?.palette?.white
            },
            ":hover .ms-Checkbox-checkmark": {
                color: theme?.palette?.white
            },
            ":hover .ms-Checkbox-label": {}
        }
    },
    disabled: {
        selectors: {
            ".ms-Checkbox-checkbox": {
                borderColor: theme?.semanticColors?.buttonBackgroundDisabled,
                backgroundColor: theme?.semanticColors?.buttonBackgroundDisabled
            },
            ":hover .ms-Checkbox-checkbox": {
                borderColor: theme?.semanticColors?.buttonBackgroundDisabled,
                backgroundColor: theme?.semanticColors?.buttonBackgroundDisabled
            },
            ".ms-Checkbox-checkmark": {
                color: theme?.semanticColors?.disabledText
            },
            ":hover .ms-Checkbox-checkmark": {
                color: theme?.semanticColors?.disabledText
            },
            label: {
                color: theme?.semanticColors?.disabledText
            }
        }
    }
})
